module.exports = __webpack_public_path__ + "img/home_actived.00a69d3a.png";